/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { ContactFinderBusinessService } from '../../resources/contact-finder-business.service';
import { ContactFinderDialogComponent } from './contact-finder-dialog.component';

export const contactFinderDialogRoute = createDialogRoute({
  component: ContactFinderDialogComponent,
  init: ContactFinderBusinessService,
});
